export default __webpack_public_path__ + "static/media/student-grid.05a60325.png";